import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement('cds-table-head')
export class TableHeadElement extends LitElement {
  @property({ type: String, reflect: true })
  role = 'rowgroup';

  render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cds-table-head': TableHeadElement;
  }
}
